var exports = {
  "rv": "KeybindHint.module__tooltipContent___MXVicG",
  "Pf": "KeybindHint.module__label___MXVicG",
  "g": "KeybindHint.module__keybindHint___MXVicG",
  "Eb": "KeybindHint.module__key___MXVicG",
  "WK": "KeybindHint.module__keySymbol___MXVicG" + " " + "KeybindHint.module__key___MXVicG",
};

module.exports = exports;
